import React, { useEffect, useState } from 'react'

export default function Lottie ({ animationData, animationUrl, loop = false, autoplay = true, ...props }) {
  const [Lottie, setLottie] = useState(null)
  const [animationJson, setAnimationJson] = useState(null)

  useEffect(() => {
    import('lottie-react').then((mod) => {
      setLottie(() => mod.default)
    })
  }, [])

  // If we have a URL, fetch the animation data
  useEffect(() => {
    if (animationUrl) {
      fetch(animationUrl)
        .then(response => response.json())
        .then(data => setAnimationJson(data))
        .catch(error => console.error('Error loading Lottie animation:', error))
    }
  }, [animationUrl])

  if (!Lottie) {
    return <div style={{ width: props.width, height: props.height }} />
  }

  // Use animationJson if we have a URL, otherwise use animationData
  const finalAnimationData = animationUrl ? animationJson : animationData

  if (!finalAnimationData) {
    return <div style={{ width: props.width, height: props.height }} />
  }

  return <Lottie animationData={finalAnimationData} loop={loop} autoplay={autoplay} {...props} />
}
